import axios from 'axios'
import classNames from 'classnames'
import {VmButton, VmText, VmView} from 'components'
import {VmHeader} from 'molecules'
import QueryString from 'qs'
import React, {useEffect, useState} from 'react'
import {useSearchParams} from 'react-router-dom'
import {toCurrency} from 'utils/functions'
import {RgxMobileDevice} from 'utils/core'

const {REACT_APP_BASE_URL_DOKTER: BASE_URL} = process.env

const BULAN_OPTS = [
  {value: 0, label: 'Semua'},
  {value: 1, label: 'Januari'},
  {value: 2, label: 'Februari'},
  {value: 3, label: 'Maret'},
  {value: 4, label: 'April'},
  {value: 5, label: 'Mei'},
  {value: 6, label: 'Juni'},
  {value: 7, label: 'Juli'},
  {value: 8, label: 'Agustus'},
  {value: 9, label: 'September'},
  {value: 10, label: 'Oktober'},
  {value: 11, label: 'November'},
  {value: 12, label: 'Desember'},
]

const yearOptions = () => {
  const now = new Date().getFullYear()
  const years = []
  for (let y = now; y >= now - 10; y -= 1) {
    years.push(y)
  }
  return years
}

const formatNum = (n) => toCurrency(n ?? 0).replace(/^Rp\s?/i, '')

export default function RiwayatPembelianPaket() {
  const [searchParams] = useSearchParams()
  const [uid] = useState(searchParams.get('dctid'))
  const [device, setDevice] = useState('web')
  const [tahun, setTahun] = useState(new Date().getFullYear())
  const [bulan, setBulan] = useState(0)
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [downloading, setDownloading] = useState(null)
  const [error, setError] = useState('')

  const fetchData = () => {
    if (!uid) {
      setError('uid tidak ditemukan')
      return
    }
    setLoading(true)
    setError('')
    axios
      .post(
        `${BASE_URL}/billing-sistem/index`,
        QueryString.stringify({
          uid,
          tahun,
          bulan,
        })
      )
      .then(({data}) => {
        if (data?.status === 0) {
          setRows([])
          setError(data.message || 'Gagal mengambil data')
          return
        }
        setRows(Array.isArray(data?.data) ? data.data : [])
      })
      .catch(() => {
        setRows([])
        setError('Gagal mengambil data riwayat pembelian')
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    setDevice(RgxMobileDevice.test(navigator.userAgent) ? 'mobile' : 'web')
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const b64ToPdfBlob = (b64) => {
    const bin = window.atob(b64)
    const bytes = new Uint8Array(bin.length)
    for (let i = 0; i < bin.length; i += 1) {
      bytes[i] = bin.charCodeAt(i)
    }
    return new Blob([bytes], {type: 'application/pdf'})
  }

  const downloadInvoice = (row) => {
    if (!row?.regd_id || !row?.regd_invoice) {
      window.alert('File Invoice Tidak Ditemukan')
      return
    }
    setDownloading(row.regd_id)
    axios
      .post(
        `${BASE_URL}/billing-sistem/get-invoice`,
        QueryString.stringify({
          uid,
          regd: row.regd_id,
        })
      )
      .then(({data}) => {
        if (!data || data.status !== 1 || !data.pdf) {
          window.alert(data?.message || 'File Invoice Tidak Ditemukan')
          return
        }
        const blob = b64ToPdfBlob(data.pdf)
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = data.filename || `${row.regd_invoice}_Bukti_Pembayaran.pdf`
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      })
      .catch(() => {
        window.alert('File Invoice Tidak Ditemukan')
      })
      .finally(() => setDownloading(null))
  }

  return (
    <div className={`px-4 pb-24 ${device === 'mobile' ? 'pt-20' : 'pt-4'}`}>
      {device === 'mobile' ? (
        <VmHeader
          HeaderMode="bg-blue-gradient"
          HeaderName={'Menu'}
          HeaderType={'Riwayat Pembelian Paket'}
          className="fixed bg-white px-4 py-4 z-10 top-0 left-0 right-0"
          classNameTitle="!pl-4"
          showBack
        />
      ) : null}

      <VmText className="text-center text-3xl font-bold text-slate-600 mb-4">
        Riwayat Pembelian Paket
      </VmText>

      <VmView className="flex flex-wrap items-end gap-3 mb-4">
        <label className="text-sm text-gray-600">
          Tahun
          <select
            className="block mt-1 border rounded-md px-3 py-2 bg-gray-100"
            value={tahun}
            onChange={(e) => setTahun(parseInt(e.target.value, 10))}
          >
            {yearOptions().map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </label>
        <label className="text-sm text-gray-600">
          Bulan
          <select
            className="block mt-1 border rounded-md px-3 py-2 bg-gray-100"
            value={bulan}
            onChange={(e) => setBulan(parseInt(e.target.value, 10))}
          >
            {BULAN_OPTS.map((b) => (
              <option key={b.value} value={b.value}>
                {b.label}
              </option>
            ))}
          </select>
        </label>
        <VmButton
          className="bg-blue-500 text-white px-4 py-2 rounded-md"
          onClick={fetchData}
        >
          Cari
        </VmButton>
      </VmView>

      {error ? (
        <VmText className="text-danger text-sm mb-2">{error}</VmText>
      ) : null}
      <VmText className="text-xs text-gray-500 mb-2">
        {loading
          ? 'Memuat data...'
          : `Menampilkan ${rows.length ? 1 : 0} - ${rows.length} data dari total ${rows.length} data.`}
      </VmText>

      <div className="overflow-x-auto shadow rounded-xl bg-white">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="p-2">No</th>
              <th className="p-2">Action</th>
              <th className="p-2">Tgl Pembayaran</th>
              <th className="p-2">No. Invoice</th>
              <th className="p-2">Nama Paket</th>
              <th className="p-2">Jenis Pembayaran</th>
              <th className="p-2 text-right">Jumlah</th>
              <th className="p-2 text-right">Harga</th>
              <th className="p-2 text-right">Diskon</th>
              <th className="p-2 text-right">Subtotal</th>
              <th className="p-2 text-right">PPN (%)</th>
              <th className="p-2 text-right">Komisi</th>
              <th className="p-2 text-right">Grandtotal</th>
            </tr>
          </thead>
          <tbody>
            {!loading && rows.length === 0 ? (
              <tr>
                <td className="p-4 text-center text-gray-500" colSpan={13}>
                  Tidak ada data yang ditemukan.
                </td>
              </tr>
            ) : (
              rows.map((row, i) => (
                <tr key={row.regd_id} className="border-t">
                  <td className="p-2">{i + 1}</td>
                  <td className="p-2">
                    <VmButton
                      className={classNames(
                        'bg-green-600 text-white text-xs px-2 py-1 rounded',
                        downloading === row.regd_id && 'opacity-50'
                      )}
                      onClick={() => downloadInvoice(row)}
                    >
                      Invoice
                    </VmButton>
                  </td>
                  <td className="p-2 whitespace-nowrap">{row.mulai}</td>
                  <td className="p-2 whitespace-nowrap">{row.regd_invoice}</td>
                  <td className="p-2">{row.regd_nama_paket}</td>
                  <td className="p-2">{row.jenis_pembayaran}</td>
                  <td className="p-2 text-right">{row.jumlah}</td>
                  <td className="p-2 text-right">{formatNum(row.regd_harga_paket)}</td>
                  <td className="p-2 text-right">{formatNum(row.regd_diskon_paket)}</td>
                  <td className="p-2 text-right">{formatNum(row.subtotal)}</td>
                  <td className="p-2 text-right">{row.regd_pajak_paket}</td>
                  <td className="p-2 text-right">{formatNum(row.regd_bonus_reseler)}</td>
                  <td className="p-2 text-right">{formatNum(row.regd_grandtotal)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
